import React from 'react';
import {GuestListModal} from './guest-list-modal';

export interface GuestUserModalProps {
  onClose: () => void;
  children?: never;
}

export const GuestUserModal: React.FC<GuestUserModalProps> = ({onClose}) => {
  return <GuestListModal onClose={onClose} />;
};
